"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var FinishAttendingComponent = /** @class */ (function () {
    function FinishAttendingComponent() {
        this.modalActions = new core_1.EventEmitter();
        this.txUpdateAttending = new core_1.EventEmitter();
        this.txFinish = new core_1.EventEmitter();
    }
    FinishAttendingComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(FinishAttendingComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinishAttendingComponent.prototype, "authenticatedUser", {
        get: function () {
            return this._authenticatedUser;
        },
        set: function (authenticatedUser) {
            this._authenticatedUser = authenticatedUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinishAttendingComponent.prototype, "canFinish", {
        get: function () {
            return this._canFinish;
        },
        set: function (canFinish) {
            this._canFinish = canFinish;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinishAttendingComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (loading) {
            this._loading = loading;
        },
        enumerable: true,
        configurable: true
    });
    FinishAttendingComponent.prototype.openModal = function () {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    };
    FinishAttendingComponent.prototype.isTechnicianScoreGiven = function () {
        return this.attending.technicianScore.score || this._hasScore;
    };
    FinishAttendingComponent.prototype.updateAttending = function () {
        this._hasScore = true;
        this.txUpdateAttending.emit();
    };
    FinishAttendingComponent.prototype.finish = function () {
        this.txFinish.emit();
    };
    FinishAttendingComponent.ctorParameters = function () { return []; };
    return FinishAttendingComponent;
}());
exports.FinishAttendingComponent = FinishAttendingComponent;
//# sourceMappingURL=finish-attending.component.js.map


// WEBPACK FOOTER //
// finish-attending.component.js